import Vue from 'vue'
import compareVersions from 'compare-versions'

export default {
  namespaced: true,
  state: {
    segments: [],
    cursor: undefined,
    currentSegment: undefined,
    updateTime: undefined,
    appIsUpdating: false,
    needAppMarketUpdate: false,
    networkError: false,
    tosDate: new Date(0)
  },
  getters: {
    run(state) {
      if (state.currentSegment === undefined) return undefined
      return state.segments[state.currentSegment].run
    },
    roundedTime(state) {
      if (state.cursor === undefined) return undefined
      const roundedDate = Math.round(state.cursor.valueOf() / 1800 / 1000) * 1800 * 1000
      return new Date(roundedDate)
    },
    date(state, getters) {
      if (getters.roundedTime === undefined) return undefined
      const date = getters.roundedTime.toISOString().split('.')
      return date[0].replace(/[^\d]/g, '')
    },
    private(state) {
      if (state.currentSegment === undefined) return undefined
      return state.segments[state.currentSegment].private
    },
    segment(state) {
      if (state.currentSegment === undefined) return undefined
      return state.segments[state.currentSegment]
    }
  },
  mutations: {
    initCursor(state) {
      if (state.appIsUpdating !== false || state.needAppMarketUpdate !== false) return
      const now = new Date()
      const offset = now.getHours() < 13 ? 0 : 24 * 3600 * 1000
      let cursor = new Date(now.valueOf() + offset)

      cursor.setHours(13)
      cursor.setMinutes(0)
      cursor.setSeconds(0)
      cursor.setMilliseconds(0)
      let currentSegment = null

      Object.keys(state.segments).forEach(key => {
        if (state.segments[key].startTime <= cursor && state.segments[key].stopTime >= cursor) {
          currentSegment = key
        }
      })

      if (currentSegment === null) throw Error('Current time segment not found')

      if (state.segments[currentSegment].private /* && window.UserId === 0 */) {
        if (offset) {
          cursor = new Date(cursor.valueOf() - offset)
          currentSegment++
        } else {
          cursor = new Date(cursor.valueOf() + (24 * 3600 * 1000))
          currentSegment--
        }
      }

      state.cursor = cursor
      state.currentSegment = currentSegment
    },
    refreshCursor(state) {
      if (state.appIsUpdating !== false || state.needAppMarketUpdate !== false) return
      const cursor = state.cursor
      let currentSegment = null

      Object.keys(state.segments).forEach(key => {
        if (state.segments[key].startTime <= cursor && state.segments[key].stopTime >= cursor) {
          currentSegment = key
        }
      })

      if (currentSegment === null) throw Error('Current time segment not found')

      state.currentSegment = currentSegment
    },
    updateSegments(state, { segments }) {
      if (state.appIsUpdating !== false || state.needAppMarketUpdate !== false) return
      const newSegments = []
      state.updateTime = new Date()
      const knownDays = []
      segments.forEach(segment => {
        if (segment.status !== 'complete') return
        if (segment.day in knownDays) return
        knownDays[segment.day] = 1

        const Y = segment.day.substr(0, 4)
        const M = segment.day.substr(4, 2)
        const D = segment.day.substr(6, 2)

        const startTime = new Date(`${Y}-${M}-${D}T04:00Z`)
        const stopTime = new Date(`${Y}-${M}-${D}T21:00Z`)

        const isPrivate = segment.private
        // const isPrivate = (stopTime.valueOf() > new Date().valueOf()) && segment.private

        newSegments.push({
          run: segment.run,
          private: isPrivate,
          startTime,
          stopTime
        })
      })
      state.segments = newSegments
    },
    seek(state, time) {
      let cursor = new Date(state.cursor.valueOf() + time)
      let currentSegment = Number(state.currentSegment)

      if (cursor < state.segments[currentSegment].startTime) {
        if ((currentSegment + 1) in state.segments) {
          currentSegment++
          if (time !== -24 * 3600 * 1000) {
            cursor = state.segments[currentSegment].stopTime
          }
        } else {
          return
          // cursor = state.segments[currentSegment].startTime
        }
      } else if (cursor > state.segments[currentSegment].stopTime) {
        if ((currentSegment - 1) in state.segments) {
          currentSegment--
          if (time !== 24 * 3600 * 1000) {
            cursor = state.segments[currentSegment].startTime
          }
        } else {
          return
          // cursor = state.segments[currentSegment].stopTime
        }
      }
      state.cursor = cursor
      state.currentSegment = currentSegment
    },
    checkAppVersions(state, versions) {
      if (!('appInfo' in navigator)) return
      const installed = navigator.appInfo.version
      const minimal = versions.minimal
      if (installed === undefined) return
      if (minimal === undefined) return
      if (compareVersions(installed, minimal) < 0) {
        state.needAppMarketUpdate = { installed, minimal }
      }
    },
    checkJsVersions(state, versions) {
      if (state.needAppMarketUpdate !== false) return
      if (window.location.port === '3000') return
      const scripts = document.getElementsByTagName('script')
      for (const script of scripts) {
        const matches = script.outerHTML.match(/\.\/(\w+)\.(\w+)\.js/)
        if (!matches) continue
        const name = matches[1]
        const currentVersion = matches[2]
        if (name in versions && versions[name] !== currentVersion) {
          // alert(`version mismatch: ${name} -> ${currentVersion} != ${versions[name]}`) // eslint-disable-line
          console.log(`version mismatch: ${name} -> ${currentVersion} != ${versions[name]}`)
          console.log('reloading...')
          if ('cordova' in window) {
            const filename = `app-update.${versions.manifest}.${versions.vendor}.${versions.client}.zip`
            state.contentSync = window.ContentSync.sync({
              src: `${Vue.config.server}/${filename}`,
              id: 'app',
              copyCordovaAssets: true
            })
            state.appIsUpdating = '0%'
            state.contentSync.on('progress', data => {
              state.appIsUpdating = `${data.progress}%`
            })
            state.contentSync.on('complete', data => {
              let cacheUrl
              if (window.device.platform === 'iOS') {
                cacheUrl = 'http://localhost:49086/'
              } else {
                cacheUrl = 'file://' + data.localPath + '/www/index.html'
              }
              state.appIsUpdating = 'ok'
              window.NativeStorage.setItem('cacheUrl', cacheUrl, () => {
                window.location.reload(true)
              }, e => {
                throw e
              })
            })
            state.contentSync.on('error', error => {
              console.error(error)
              state.appIsUpdating = 'error'
              setTimeout(() => {
                document.location.reload(true)
              }, 60000)
            })
          } else {
            document.location.reload(true)
          }
          return
        }
      }
    },
    setNetworkError(state, val) {
      state.networkError = val
    },
    setTosDate(state, date) {
      state.tosDate = new Date(date)
    }
  },
  actions: {
    fetchSegments(context, isRefresh) {
      let statusEndpoint = '_mtopara_dev_' in window ? 'status-dev.php' : 'status.php'
      statusEndpoint += `?refresh=${new Date().valueOf()}`
      if ('appInfo' in navigator) statusEndpoint += `&app=${navigator.appInfo.version}`
      Vue.http.get(statusEndpoint).then(({ body: response }) => {
        // if (!isRefresh) {
        context.commit('checkAppVersions', response.app)
        context.commit('checkJsVersions', response.js)
        // }
        if (response.redirect !== undefined) {
          document.location = response.redirect
          return
        }
        if (response.france === undefined) throw new Error('domain not found')
        context.commit('updateSegments', { segments: response.france })
        context.commit('setTosDate', response.tos)
        if (isRefresh) {
          context.commit('refreshCursor')
        } else {
          context.commit('initCursor')
        }
      }).catch(() => {
        context.commit('setNetworkError', true)
        setTimeout(() => document.location.reload(true), 60 * 1000)
      })
    },
    seek(context, time) {
      context.commit('seek', time)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/time.js